var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appContainer"},[_c('AppAside'),_c('AppHeader'),_c('AppMain',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"加载中"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }